var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "icon",
    class: [{
      'is-spinning': _vm.spinning,
      'is-prominent': _vm.prominent,
      'justify-center': _vm.center
    }, _vm.colorString ? 'text-' + _vm.colorString : ''],
    style: _vm.iconStyle,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('svg', {
    style: _vm.iconStyle,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": '0 0 24 24',
      "height": _vm.computedSize,
      "width": _vm.computedSize,
      "role": "img",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.icon
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }